/**
 * Mock mission data for list and detail views.
 * Structure matches mission-details.html and missionInput schema.
 */

export const mockMissions = [
  {
    missionId: "mission-1",
    title: "Hurricane Relief Transport - Medical Supplies",
    description:
      "Urgent delivery of critical medical supplies to storm-affected region",
    departure: "Atlanta, GA",
    arrival: "Key West, FL",
    departureAirportId: "ATL",
    arrivalAirportId: "EYW",
    dateTime: "2024-03-15 08:00 EST",
    status: "Active",
    postedBy: "John Smith",
    minHours: "500",
    minRating: "Commercial",
    interestedPilots: "12",
    favoritedBy: "Alice Johnson, Bob Williams, Carol Davis",
    confirmedPilotCertificateNumber: "CFI-12345678",
    pilotStatus: "Pilot Chosen",
    cargoStatus: "Cargo Sourced",
    contributingOrgs: ["Red Cross", "FEMA", "Angel Flight"],
    cargoItems: [
      {
        description: "Medical Supplies - First Aid Kits",
        weightLbs: 150,
        sourcedWeightLbs: 150,
        isSourced: "Yes",
        providedByOrgId: "ORG-001",
        isDeliveredToAirport: "Yes",
        linkedRequestId: "REQ-789",
      },
      {
        description: "Water Purification Tablets",
        weightLbs: 50,
        sourcedWeightLbs: 30,
        isSourced: "Partial",
        providedByOrgId: "ORG-002",
        isDeliveredToAirport: "No",
        linkedRequestId: "REQ-790",
      },
    ],
    PassengerItem: [
      {
        fullName: "Dr. Emily Carter",
        age: 42,
        weightLbs: 140,
        specialNeeds: "None",
        isConfirmed: "Yes",
        linkedRequestId: "REQ-791",
      },
      {
        fullName: "Nurse Sarah Martinez",
        age: 35,
        weightLbs: 130,
        specialNeeds: "Requires oxygen tank",
        isConfirmed: "Yes",
        linkedRequestId: "REQ-792",
      },
    ],
    missionPOCName: "Michael Thompson",
    missionPOCPhone: "+1 (555) 123-4567",
    missionPOCOrgId: "ORG-MAIN-001",
    missionCategory: "Medical Emergency",
    disasterCode: "HURR-2024-003",
    milesCovered: 478.5,
    livesImpacted: 250,
    linkedRequestId: 12345,
  },
  {
    missionId: "mission-2",
    title: "Wildfire Evacuation Support",
    description: "Air lift support for evacuation and supply runs in affected zone",
    departure: "Denver, CO",
    arrival: "Boise, ID",
    departureAirportId: "DEN",
    arrivalAirportId: "BOI",
    dateTime: "2024-03-20 06:00 MST",
    status: "Active",
    postedBy: "Jane Doe",
    minHours: "300",
    minRating: "Instrument",
    interestedPilots: "5",
    favoritedBy: "Mike Brown",
    confirmedPilotCertificateNumber: "",
    pilotStatus: "Pilot Needed",
    cargoStatus: "Cargo Needed",
    contributingOrgs: ["State EMA", "USFS"],
    cargoItems: [],
    PassengerItem: [
      {
        fullName: "Fire crew lead",
        age: 38,
        weightLbs: 180,
        specialNeeds: "None",
        isConfirmed: "Yes",
        linkedRequestId: "",
      },
    ],
    missionPOCName: "Capt. David Lee",
    missionPOCPhone: "+1 (555) 987-6543",
    missionPOCOrgId: "ORG-FIRE-002",
    missionCategory: "Disaster Response",
    disasterCode: "WILD-2024-012",
    milesCovered: 0,
    livesImpacted: 0,
    linkedRequestId: null,
  },
];

export default mockMissions;
